import $ from 'jquery'
import lottie from 'lottie-web'
import * as animationData_0 from './data/points_0.json'
import * as animationData_1 from './data/points_1.json'
import 'slick-carousel'

$(document).ready(function() {
  dhsv_vc_hero()
})

function dhsv_vc_hero() {
  $('.dhsv_vc_hero').each(function() {
    var firstSlideAnim = document.getElementById('hero-animation_0')
    var firstAnimParams = {
      container: firstSlideAnim,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: animationData_0.default,
      rendererSettings: {
        preserveAspectRatio: 'xMinYMax meet',
      },
    }
    var firstAnimation = lottie.loadAnimation(firstAnimParams)

    startAnim()

    function startAnim() {
      firstAnimation.setSpeed(0.125)
      firstAnimation.play()
    }
  })

  $('.default-anim').each(function() {
    var container = $(this)
    console.log(container) //eslint-disable-line

    var animParams = {
      container: container[0],
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: animationData_1.default,
    }
    var defaultAnimation = lottie.loadAnimation(animParams)

    startDefaultAnim()

    function startDefaultAnim() {
      defaultAnimation.setSpeed(0.125)
      defaultAnimation.play()
    }
  })

  $('.hero-slider').slick({
    infinite: true,
    dots: false,
    fade: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.dhsv_vc_hero .slider-nav .prev'),
    nextArrow: $('.dhsv_vc_hero .slider-nav .next'),
  })

  $('.hero-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.dhsv_vc_hero .slider-nav .active').removeClass('active')
    $(`a.entry[data-slide="${currentSlide}"]`).addClass('active')
  })

  $('a[data-slide]').click(function(e) {
    e.preventDefault()
    var slideno = $(this).data('slide')
    $('.hero-slider').slick('slickGoTo', slideno)
    $('.dhsv_vc_hero .slider-nav .active').removeClass('active')
    $(this).addClass('active')
  })
}
